import { CURRENT_TERMS_VERSION } from '@workspace/seedforge-shared'
import { Button } from '@workspace/ui/components/button'
import { Checkbox } from '@workspace/ui/components/checkbox'
import { useState } from 'react'
import { useAcceptTermsMutation } from '../../../hooks/api'
import { TERMS_COPY } from '../copy/terms-copy'

const WEB_URL = import.meta.env.VITE_WEB_URL ?? 'https://seedforge.com'

// The checkbox, the links and the accept button. Shared by the sign-in step and the overlay for onboarded accounts.
export function TermsAgreement() {
  const [agreed, setAgreed] = useState(false)
  const acceptTerms = useAcceptTermsMutation()

  return (
    <div className="space-y-4">
      <label htmlFor="terms-agree" className="flex items-start gap-3 text-sm">
        <Checkbox
          id="terms-agree"
          checked={agreed}
          onCheckedChange={(checked) => setAgreed(checked === true)}
          className="mt-0.5"
        />
        <span>
          {TERMS_COPY.agreePrefix}{' '}
          <a
            href={`${WEB_URL}/terms`}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            {TERMS_COPY.termsLink}
          </a>{' '}
          {TERMS_COPY.agreeJoiner}{' '}
          <a
            href={`${WEB_URL}/privacy`}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            {TERMS_COPY.privacyLink}
          </a>
        </span>
      </label>

      {acceptTerms.isError && (
        <p className="text-sm text-destructive" role="alert">
          {TERMS_COPY.saveError}
        </p>
      )}

      <Button
        disabled={!agreed || acceptTerms.isPending}
        onClick={() => acceptTerms.mutate({ body: { version: CURRENT_TERMS_VERSION } })}
      >
        {TERMS_COPY.accept}
      </Button>
    </div>
  )
}
